export var TransactionMode;
(function (TransactionMode) {
    TransactionMode["READ_ONLY"] = "readonly";
    TransactionMode["READ_WRITE"] = "readwrite";
    TransactionMode["VERSION_CHANGE"] = "versionchange";
})(TransactionMode || (TransactionMode = {}));
//# sourceMappingURL=engine.js.map